import { render, staticRenderFns } from "./m-move-file.vue?vue&type=template&id=ad4c4514&"
import script from "./m-move-file.vue?vue&type=script&lang=js&"
export * from "./m-move-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports